import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '../../../styles/style-utils';

import Section from '../../common/Section';
import Anchor from '../utils/Anchor';
import PressQuotes from './PressQuotes';
import FeaturedReview from './FeaturedReview';

const Wrapper = styled(Section)`
  padding: var(--fr);
  background-color: ${props => props.bgColor || 'var(--c-shark)'};

  ${media.large`
    padding: var(--fr) 0;
  `}
`;

/* Stacked, the featured review comes first. Side by side, the press quotes lead. */
const Grid = styled.div`
  display: grid;
  grid-gap: var(--fr);
  grid-template-columns: 1fr;

  ${media.large`
    grid-template-columns: 1fr 2fr;

    > :first-child {
      order: 2;
    }

    > :last-child {
      order: 1;
    }
  `}
`;

const ReviewsSection = ({ content }) => {
  return (
    <React.Fragment>
      <Anchor id="reviews" />
      <Wrapper bgColor={content.bgColor}>
        <Grid>
          <FeaturedReview />
          <PressQuotes />
        </Grid>
      </Wrapper>
    </React.Fragment>
  );
};

ReviewsSection.propTypes = {
  content: PropTypes.object.isRequired,
};

export default ReviewsSection;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/reviews/ReviewsSection.js